import script from "./CommentReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentReactions.vue?vue&type=script&setup=true&lang=js"

import "./CommentReactions.vue?vue&type=style&index=0&id=2d224a3e&lang=scss"

const __exports__ = script;

export default __exports__